module.exports = __webpack_public_path__ + "img/familia.c832041c.png";